<h3 mat-dialog-title *ngIf="!userGroupChanged">Are you sure?</h3>
<h3 mat-dialog-title *ngIf="userGroupChanged">Report's criteria changed</h3>


<mat-dialog-content *ngIf="ready$ | async">
  <p *ngIf="!userGroupChanged">By Changing the Retailer selection, you'll lose the following:</p>
  <p *ngIf="userGroupChanged">The following has been removed due to Access Group change:</p>

  <div class="columns">

    <div class="column" *ngIf="summary.upcFilters.length">
      <h3 class="column-label">UPC Filters:</h3>
      <ul>
        <li *ngFor="let f of summary.upcFilters" class="remove">
          {{ f.field.display }} ({{ f.field.retailer }})
        </li>
      </ul>
    </div>

    <div class="column" *ngIf="summary.locationFilters.length">
      <h3 class="column-label">Transaction Filters:</h3>
      <ul>
        <li *ngFor="let f of summary.locationFilters" class="remove">
          {{ f.field.display }} ({{ f.field.retailer }})
        </li>
      </ul>
    </div>

    <div class="column" *ngIf="summary.cgs.length">
      <h3 class="column-label">Comparison Groups:</h3>
      <div *ngFor="let cg of summary.cgs">
        <h5>Comparison Group: {{cg.cgName}}</h5>
        <ul>
          <li *ngFor="let f of cg.filters" class="remove">
            {{ f.field.display }} ({{ f.field.retailer }})
          </li>
        </ul>
      </div>
    </div>

    <div class="column" *ngIf="summary.sovs.length">
      <h3 class="column-label">Source of Volumes:</h3>
      <div *ngFor="let sov of summary.sovs">
        <h5>Comparison Group: {{sov.cgName}}</h5>
        <ul>
          <li class="remove">
            {{ sov.dim.display }} ({{ sov.dim.retailer }})
          </li>
        </ul>
      </div>
    </div>

  </div>

</mat-dialog-content>

<mat-dialog-actions *ngIf="!userGroupChanged">
  <button mat-stroked-button color="accent" (click)="cancel()" class="secondary-button">Cancel</button>
  <button mat-raised-button color="accent" (click)="confirm()" cdkFocusInitial>Confirm</button>
</mat-dialog-actions>
<mat-dialog-actions *ngIf="userGroupChanged">
  <button mat-raised-button color="accent" (click)="cancel()">OK</button>
</mat-dialog-actions>
